module.exports = __webpack_public_path__ + "img/17.aaa2e001.jpg";